import * as React from 'react';
import { Button as BaseButton } from 'antd';
import { DeleteFilled } from '@ant-design/icons';



const DeleteButton = ({ disabled, onClick, loading }) => {
    return (
        <BaseButton
            type="primary"
            danger={!disabled}
            loading={loading}
            size="large"
            disabled={disabled}
            shape="circle"
            onClick={onClick}
            icon={<DeleteFilled/>}
        />
    );
};
export default DeleteButton;